import * as Icons from "lucide-react";
import { MODULES } from "../lib/brand";
import { CTA, GlassCard, PageHeader, SectionHeading, Shell } from "../components/site/Primitives";

const SOLUTIONS = [
  ["Capture every enquiry", "Calls, forms, SMS, WhatsApp and email land in one system with an owner and a next step.", "Inbox"],
  ["Respond in seconds", "AI acknowledges, qualifies and offers real availability without waiting for a human.", "Timer"],
  ["Fill the calendar", "Booking, confirmation, reminders and rescheduling handled end to end.", "CalendarCheck"],
  ["Never drop a follow-up", "Sequences run until someone replies, then hand over cleanly.", "Repeat"],
  ["Keep one customer truth", "Full history on every record: calls, messages, appointments, payments.", "Database"],
  ["Report on outcomes", "Pipeline, conversion, response time and revenue in one operational view.", "BarChart3"],
];

export default function Solutions() {
  return (
    <div data-testid="solutions-page">
      <PageHeader
        testId="solutions-title"
        eyebrow="Solutions"
        title="Automate the work between the first conversation and the final conversion."
        sub="Elvoria AI is assembled from modules that share one database, one customer record and one set of automation rules."
      />

      <section className="py-20">
        <Shell>
          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {SOLUTIONS.map(([title, detail, icon], i) => {
              const Icon = Icons[icon] || Icons.Sparkles;
              return (
                <GlassCard key={title} testId={`solution-card-${i}`} className="p-6">
                  <Icon className="h-5 w-5 text-elv-green" />
                  <p className="mt-4 text-base font-semibold text-elv-text">{title}</p>
                  <p className="mt-2.5 text-sm leading-relaxed text-elv-dim">{detail}</p>
                </GlassCard>
              );
            })}
          </div>
        </Shell>
      </section>

      <section className="border-y border-elv-line bg-[#070A0F] py-20">
        <Shell>
          <SectionHeading
            testId="solutions-modules-heading"
            eyebrow="Modules"
            title="Fifteen modules, one operating system."
            sub="Turn on what you need now. The rest stays available without a migration later."
          />
          <div className="mt-12 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
            {MODULES.map(([name, description], i) => (
              <div
                key={name}
                data-testid={`solutions-module-${i}`}
                className="flex items-start gap-3 rounded-md border border-white/[0.06] bg-white/[0.02] p-4"
              >
                <span className="font-mono text-[11px] text-elv-green">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <p className="text-sm font-medium text-elv-text">{name}</p>
                  <p className="mt-1.5 text-xs text-elv-dim">{description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-12">
            <CTA to="/book-demo" testId="solutions-cta">
              Get My Free Automation Audit
            </CTA>
          </div>
        </Shell>
      </section>
    </div>
  );
}
